<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'dispositivos' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <div class="d-flex mt-4">
      <p style="font-weight: 500">
        {{ $t("vDispositivos.seleccioneDispositivo") }}:
      </p>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group class="inputRadioGroup" v-model="selectedGps" :options="translateRadio"
          :aria-describedby="ariaDescribedby" name="radio-inline"
          @change="mostrarCard(selectedGps)"></b-form-radio-group>
      </b-form-group>
    </div>

    <b-card class="mx-auto mt-3" tile v-if="mostrar">
      <h4 class="mb-3">{{ $t("vDispositivos.dispositivoInstitucional") }}</h4>
      <span>*{{ $t("Gral.camposObligatorios") }}</span>
      <h5 class="text-center text-danger" v-if="estatusImei">
        El IMEI ya está registrado, ingrese otro por favor.
      </h5>
      <h5 class="text-center text-danger" v-if="estatusSerial">
        El serial ya está registrado, ingrese otro por favor.
      </h5>
      <b-overlay rounded opacity="0.6" spinner-variant="primary" class="col-12 d-inline-block">
        <template #overlay>
          <b-card :title="this.$t('vDispositivos.msgConfigDispo')" class="text-center">
            <b-overlay rounded opacity="0.6" spinner-variant="primary" class="col-12 d-inline-block mt-2">
            </b-overlay>
          </b-card>
        </template>
        <b-form @submit.stop.prevent="registrarDispositivoInst">
          <b-col cols="12" sm="12">
            <div class="row">
              <b-col cols="12" sm="12">
                <label for="“nombre”">{{ $t("Gral.nombre") }}* :</label>
                <b-form-input id="nombre" v-model="dispositivoInstitucional.nombre" required autocomplete="off">
                </b-form-input>
                <b-form-invalid-feedback id="nombre-invalid">
                  {{ $t("vDispositivos.msgIngresarN") }}
                </b-form-invalid-feedback>
              </b-col>
            </div>
            <div class="row">
              <b-col cols="12" sm="6">
                <label for="“telefono”">Serial*:</label>
                <b-form-input id="telefono" v-model="dispositivoInstitucional.serial" required
                  :state="dispositivoInstitucional.serial.length === 9"
                  aria-describedby="input-live-help-telefono input-live-feedback-telefono input-live-feedback-serial"
                  autocomplete="off">
                </b-form-input>
                <b-form-invalid-feedback v-if="dispositivoInstitucional.serial.length !== 9" id="input-live-feedback">
                  El serial debe tener 9 caracteres
                </b-form-invalid-feedback>
                <b-form-text v-if="estatusSerial" id="input-live-feedback-serial" style="color: red !important">
                  ¡Ingrese un serial diferente!
                </b-form-text>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6">
                <label for="“telefono”">IMEI*:</label>
                <b-form-input class="dropdown-bg" id="imei" v-model="dispositivoInstitucional.imei" required
                  type="number" :state="dispositivoInstitucional.imei.length === 15"
                  aria-describedby="input-live-help input-live-feedback-ime-caracteres input-live-feedback-imei2"
                  autocomplete="off" @input="contarDigitos">
                </b-form-input>
                <b-form-invalid-feedback v-if="dispositivoInstitucional.imei.length !== 15"
                  id="input-live-feedback-ime-caracteres">
                  El IMEI debe tener 15 caracteres
                </b-form-invalid-feedback>
                <b-form-text v-if="estatusImei" id="input-live-feedback-imei2" style="color: red !important">
                  ¡Ingrese un IMEI diferente!
                </b-form-text>
              </b-col>
            </div>
            <b-row>

              <!--TEMPLATE SELECT GRUPO y USUARIO (ROL MASTER)-->
              <template v-if="isMaster">
                <!--Input Select GRUPO-->
                <b-col sm="12" md="6" lg="6" class="mb-3">
                  <label for="“nombre”">{{ $t("vDispositivos.msgGrupo") }}* :</label>

                  <multiselect id="area" v-model="selectedAreaId" :options="areasList" :multiple="false"
                    :selectLabel="$t('vHistorico.presioneAgregar')" emptyLabel="No se encontraron elementos"
                    :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                    :placeholder="$t('vDispositivos.msgSelecGrupo')" track-by="id" label="nombre" @input="inputSelect">
                    <span slot="noResult">
                      {{ $t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

                <!--Input Select USUARIOS-->
                <b-col cols="12" sm="12" md="6" lg="6" v-if="selectedAreaId != null">
                  <label for="“usuarios”">{{ $t("vDispositivos.msgAsigUsers") }}:</label>
                  <multiselect id="usuarios1" v-model="dispositivoInstitucional.usuarios" :options="usersByGroupList"
                    :multiple="true" :selectLabel="$t('vHistorico.presioneAgregar')"
                    emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                    :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                    track-by="matricula" label="matricula">
                    <span slot="noResult">
                      {{ this.$t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

              </template>
              <!--TEMPLATE SELECT GRUPO y USUARIO (ROL ADMINISTRADORES)-->
              <template v-else>

                <!--Input Select GRUPO-->
                <b-col sm="12" md="6" lg="6" class="mb-3">
                  <label for="“nombre”">{{ $t("vDispositivos.msgGrupo") }}* :</label>

                  <multiselect id="areaRolAdmin" v-model="selectedAreaId" :options="areasListForUserAdministrador"
                    :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                    emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                    :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vDispositivos.msgSelecGrupo')"
                    track-by="id" label="nombre" @input="inputSelect">
                    <span slot="noResult">
                      {{ $t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

                <!--Input Select USUARIOS-->
                <b-col cols="12" sm="12" md="6" lg="6">
                  <label for="“usuarios”">{{
                    $t("vDispositivos.msgAsigUsers")
                  }}</label>
                  <multiselect id="usuarios2" v-model="dispositivoInstitucional.usuarios" :options="usersByGroupList"
                    :multiple="true" :selectLabel="$t('vHistorico.presioneAgregar')"
                    :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                    :placeholder="$t('Gral.escribaBuscar')" track-by="matricula" label="matricula">
                    <span slot="noResult">
                      {{ this.$t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

              </template>

            </b-row>
            <b-row>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-end">
                <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" :pressed.sync="btn"
                  type="submit" :disabled="validacionesDispoInst()">
                  {{ this.$t("Gral.guardarCont") }}
                </b-btn>
              </div>
              <div
                class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-center margin-top-div">
                <b-btn color="primary" class="mt-2 ancho-boton text-light w-100" to="/Dispositivos">
                  {{ this.$t("Gral.cancelar") }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex margin-top-div">
                <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" type="submit"
                  :disabled="validacionesDispoInst()">
                  {{ $t("vDispositivos.msgSaveDispo") }}
                </b-btn>
              </div>
            </b-row>
          </b-col>
        </b-form>
      </b-overlay>
    </b-card>

    <b-card class="mx-auto mt-3" tile v-else>
      <h4 class="mb-3">{{ $t("vDispositivos.dispositivoComercial") }}</h4>
      <span>*{{ $t("Gral.camposObligatorios") }}</span>
      <h5 class="text-center text-danger" v-if="estatusImei">
        El I{{ this.limpiarTexto(translateLabel) }} ya está registrado, ingrese
        otro por favor.
      </h5>
      <h5 class="text-center text-danger" v-if="estatusTelefono">
        El teléfono ya está registrado, ingrese otro por favor.
      </h5>
      <b-overlay rounded opacity="0.6" spinner-variant="primary" class="col-12 d-inline-block">
        <template #overlay>
          <b-card :title="this.$t('vDispositivos.msgConfigDispo')" class="text-center">
            <b-overlay rounded opacity="0.6" spinner-variant="primary" class="col-12 d-inline-block mt-2">
            </b-overlay>
          </b-card>
        </template>
        <b-form @submit.stop.prevent="registrarDispositivo">
          <b-col cols="12" sm="12">
            <div class="row">
              <b-col cols="12" sm="6">
                <label for="“nombre2”">{{ $t("Gral.nombre") }}* :</label>
                <b-form-input id="nombre2" v-model="dispositivo.nombre" required autocomplete="off">
                </b-form-input>
                <b-form-invalid-feedback id="nombre-invalid2">
                  {{ $t("vDispositivos.msgIngresarN") }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col cols="12" sm="6">
                <label for="“password”">{{ $t("vDispositivos.msgPass") }}* :</label>
                <b-form-input id="password" v-model="dispositivo.contrasena" required :state="passwordState"
                  autocomplete="off">
                </b-form-input>
                <b-form-invalid-feedback id="password-invalid">
                  {{ $t("vDispositivos.msgIngresePass") }}
                </b-form-invalid-feedback>
                <b-form-text v-if="!!passwordState" id="input-live-help-password">
                  {{ $t("vDispositivos.msgFormatPass") }}
                </b-form-text>
              </b-col>
            </div>
            <div class="row">
              <b-col sm="12" md="6" lg="6" class="mb-3">
                <label for="“nombre”">Seleccione el código de país* :</label>

                <multiselect id="pais" v-model="selectedPaisId" :options="countryOptions" :multiple="false"
                  track-by="iso" label="label" :selectLabel="$t('vHistorico.presioneAgregar')"
                  emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" @input="inputSelectPais"
                  :placeholder="$t('vHistorico.mssgSelectCodigoPais')">
                  <span slot="noResult">
                    {{ $t("vHistorico.msgBusquedaFallida") }}
                  </span>
                </multiselect>

              </b-col>
              <b-col cols="12" sm="6">
                <label for="telefono2">{{ $t("Gral.tel") }}</label>

                <b-input-group>
                  <b-input-group-prepend is-text>
                    {{ selectedDialCode }}
                  </b-input-group-prepend>

                  <b-form-input id="telefono2" v-model="dispositivo.telefono" required :state="phoneState"
                    aria-describedby="input-live-feedback-telefono" autocomplete="off" @input="onPhoneInput"
                    placeholder="Ingrese el número (puedes usar + o formato local)" />

                  <!-- ✅ Mensaje de error dentro del grupo -->
                  <b-form-invalid-feedback v-if="phoneState === false" id="input-live-feedback-telefono">
                    {{ phoneValidationMessage }}
                  </b-form-invalid-feedback>
                </b-input-group>

                <b-form-text v-if="estatusTelefono" id="input-live-feedback-2" style="color: red !important">
                  ¡Ingrese un número de teléfono diferente!
                </b-form-text>
              </b-col>
            </div>
            <b-row>
              <b-col cols="12" sm="6">
                <label for="“modelo”">{{ $t("Gral.modelo") }}* :</label>

                <multiselect id="pais2" v-model="selectedGPSModel" :options="gpsModelList" :multiple="false"
                  track-by="id" label="modelo" :selectLabel="$t('vHistorico.presioneAgregar')"
                  emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vDispositivos.msgSelecModelo')"
                  @input="modeloSelected">
                  <span slot="noResult">
                    {{ $t("vDispositivos.msgSelecModelo") }}
                  </span>
                </multiselect>

              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6">
                <label for="“imei2”">{{ translateLabel }}</label>
                <b-form-input class="dropdown-bg" id="imei2" v-model="dispositivo.imei" required type="number" :state="(dispositivo.imei.length === 15 &&
                  translateLabel.includes('IMEI')) ||
                  (dispositivo.imei.length === 10 &&
                    translateLabel.includes('ID'))
                  ? true
                  : false
                  " aria-describedby="input-live-help input-live-feedback-imei input-live-feedback-id"
                  autocomplete="off" @input="contarDigitos">
                </b-form-input>
                <b-form-invalid-feedback v-if="
                  translateLabel.includes('IMEI') &&
                  dispositivo.imei.length !== 15
                " id="input-live-feedback-imei">
                  El IMEI debe tener 15 caracteres
                </b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="
                  translateLabel.includes('ID') &&
                  dispositivo.imei.length !== 10
                " id="input-live-feedback-id">
                  El ID debe tener 10 caracteres
                </b-form-invalid-feedback>
                <b-form-text v-if="estatusImei" id="input-live-warning" style="color: red !important">
                  ¡Ingrese un {{ limpiarTexto(translateLabel) }} diferente!
                </b-form-text>
              </b-col>

              <!--TEMPLATE SELECT GRUPO y USUARIO (ROL MASTER)-->
              <template v-if="isMaster">
                <!--Input Select GRUPO-->
                <b-col cols="12" sm="6" class="mb-3">
                  <label for="“nombre”">{{ $t("vDispositivos.msgGrupo") }}* :</label>

                  <multiselect id="area2" v-model="selectedAreaId" :options="areasList" :multiple="false"
                    :selectLabel="$t('vHistorico.presioneAgregar')" emptyLabel="No se encontraron elementos"
                    :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                    :placeholder="$t('vDispositivos.msgSelecGrupo')" track-by="id" label="nombre" @input="inputSelect">
                    <span slot="noResult">
                      {{ $t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>
                <!--Input Select USUARIOS-->
                <b-col cols="12" sm="6" v-if="selectedAreaId != null">
                  <label for="“usuarios”">{{ $t("vDispositivos.msgAsigUsers") }}:</label>
                  <multiselect id="usuarios3" v-model="dispositivo.usuarios" :options="usersByGroupList"
                    :multiple="true" :selectLabel="$t('vHistorico.presioneAgregar')"
                    emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                    :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                    track-by="matricula" label="matricula">
                    <span slot="noResult">
                      {{ this.$t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

              </template>
              <!--TEMPLATE SELECT GRUPO y USUARIO (ROL ADMINISTRADORES)-->
              <template v-else>
                <!--Input Select GRUPO-->
                <b-col cols="12" sm="6" class="mb-3">
                  <label for="“nombre”">{{ $t("vDispositivos.msgGrupo") }}* :</label>

                  <multiselect id="area3" v-model="selectedAreaId" :options="areasListForUserAdministrador"
                    :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                    emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                    :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vDispositivos.msgSelecGrupo')"
                    track-by="id" label="nombre" @input="inputSelect">
                    <span slot="noResult">
                      {{ $t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

                <!--Input Select USUARIOS-->
                <b-col cols="12" sm="6">
                  <label for="“usuarios”">{{
                    $t("vDispositivos.msgAsigUsers")
                  }}</label>
                  <multiselect id="usuarios4" v-model="dispositivo.usuarios" :options="usersByGroupList"
                    :multiple="true" :selectLabel="$t('vHistorico.presioneAgregar')"
                    :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                    :placeholder="$t('Gral.escribaBuscar')" track-by="matricula" label="matricula">
                    <span slot="noResult">
                      {{ this.$t("vHistorico.msgBusquedaFallida") }}
                    </span>
                  </multiselect>
                </b-col>

              </template>

            </b-row>
            <b-row>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-end">
                <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" :pressed.sync="btn"
                  type="submit" :disabled="validaciones()">
                  {{ this.$t("Gral.guardarCont") }}
                </b-btn>
              </div>
              <div
                class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-center margin-top-div">
                <b-btn color="primary" class="mt-2 ancho-boton text-light w-100" to="/Dispositivos">
                  {{ this.$t("Gral.cancelar") }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex margin-top-div">
                <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" type="submit"
                  :disabled="validaciones()">
                  {{ $t("vDispositivos.msgSaveDispo") }}
                </b-btn>
              </div>
            </b-row>
          </b-col>
        </b-form>
      </b-overlay>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import UsersDataService from "../../../services/UsersDataService";
import DevicesDataService from "@/services/DevicesDataService";
import AreaDataService from "@/services/AreaDataService";
import Multiselect from "vue-multiselect";
import AccionesDataService from "../../../services/AccionesDataService";
import * as Utils from "../../../utils/Utils";
import { verificarAcceso } from "../../../utils/Session";
import ModelosDataService from "../../../services/ModelosDataService";
import Crypto from "../../../services/Crypto";

import countries from "../../../utils/countries.json";

import ConfiguracionesDataService from "../../../services/ConfiguracionesDataService";

export default {
  name: "add_Dispositivo",
  components: { Multiselect },
  data() {
    return {
      /** Lista que almacena (rá) los modelos de GPS */
      gpsModelList: [],
      /** Objeto que almacena (rá) el modelo de GPS seleccionado */
      selectedGPSModel: null,
      /** Variable de diseño para mostrar la leyenda de ID o IMEI en el componente que lo invoque */
      txtImei: "",
      /** Variable de diseño para mostrar el numero de dígitos a contener en el ID/IMEI */
      txtFormato: null,
      /** Variable encargada de almacenar la expresion regular */
      pattern: "^\\d{-1}$",
      /** Variable bandera encargada de activar/desactivar el overload */
      busy: false,
      /** Objeto encargado de almacenar un dispositivo */
      dispositivo: {
        id: 0,
        nombre: "",
        contrasena: "",
        imei: "",
        modelo: null,
        telefono: "",
        usuarios: [],
        compartirLink: false,
        compartirHasta: 0,
        iso: "",
        paisNombre: "",
        dialCode: ""
      },

      dispositivoInstitucional: {
        id: 0,
        nombre: "",
        serial: "",
        imei: "",
        usuarios: [],
        compartirLink: false,
        compartirHasta: 0,
      },

      /** Lista que almacena los usuarios que pertenecen a un grupo/área en específico */
      usersByGroupList: [],

      btn: false,

      /** Variable que almacena el id del grupo/área seleccionada al cual pertenecera un dispositivo GPS */
      selectedAreaId: "",

      selectedInstAreaId: "",

      /** Lista que almacena las areas/grupos registrados en BD */
      areasList: [],
      areasListForUserAdministrador: [],
      /** Variable booleana encargada de verificar si el usuario logueado es master */
      isMaster: false,

      selected: [],
      /** Lista que almacena los usuarios finales registrados en BD */
      endUsersList: [],

      submitted: false,

      /** Variable encargada de almacenar la accion que se acaba de realizar sobre la vista */
      accion: "",
      /** Variable encargada de almacenar el usuario logueado en el sistema */
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),

      filtro: null,

      /**
       * Variable boolena encargada de verificar cuando un modelo de dispositivo seleccionado en Generico
       * Nota: Unicamente los modelos de GPS pertenecientes a las marcas COBAN y TKSTAR son compatibles
       * con el sistema, los que no estan dentro de estas marcas, serán tomadas como "Genericas"
       */
      isGenericGPS: false,
      key: "",
      mostrar: false,
      selectedGps: "2",
      options: [
        { text: "comercial", value: "2" },
        { text: "institucional", value: "1" },
      ],
      estatusImei: false,
      estatusSerial: false,

      estatusTelefono: false,

      // iso seleccionado por defecto
      selectedPaisId: "",

      exampleMap: {
        MX: "+52 55 1234 5678",
        CO: "+57 300 123 4567",
        AR: "+54 9 11 1234 5678",
        US: "+1 555 123 4567",
        CA: "+1 416 123 4567",
        PE: "+51 9 123 456 78",
      },

      // regex map por país
      regexMap: {
        AR: /^(?:\+54)?\d{10}$/,               // Argentina: 10
        BO: /^(?:\+591)?\d{8}$/,               // Bolivia: 8
        BR: /^(?:\+55)?\d{10,11}$/,            // Brasil: 10 o 11
        CL: /^(?:\+56)?\d{8,9}$/,              // Chile: 8 o 9
        CO: /^(?:\+57)?\d{10}$/,               // Colombia: 10
        CR: /^(?:\+506)?\d{8}$/,               // Costa Rica: 8
        CU: /^(?:\+53)?\d{8}$/,                // Cuba: 8
        DO: /^(?:\+1)?\d{10}$/,                // Rep. Dominicana (NANP): 10
        EC: /^(?:\+593)?\d{9}$/,               // Ecuador: 9
        SV: /^(?:\+503)?\d{8}$/,               // El Salvador: 8
        GT: /^(?:\+502)?\d{8}$/,               // Guatemala: 8
        HN: /^(?:\+504)?\d{8}$/,               // Honduras: 8
        MX: /^(?:\+52)?\d{10}$/,               // Mexico: 10
        NI: /^(?:\+505)?\d{8}$/,               // Nicaragua: 8
        PA: /^(?:\+507)?\d{8}$/,               // Panama: 8
        PY: /^(?:\+595)?\d{8,9}$/,             // Paraguay: 8 o 9
        PE: /^(?:\+51)?\d{9}$/,                // Peru: 9
        PR: /^(?:\+1)?\d{10}$/,                // Puerto Rico (NANP): 10
        UY: /^(?:\+598)?\d{8,9}$/,             // Uruguay: 8 ó 9
        VE: /^(?:\+58)?\d{10}$/,               // Venezuela: 10
        CA: /^(?:\+1)?\d{10}$/,                // Canada (NANP): 10
        US: /^(?:\+1)?\d{10}$/                 // Estados Unidos (NANP): 10
      },

      // mensaje de validación que utilizamos para mostrar al usuario
      phoneValidationMessage: ''
    };
  },
  beforeCreate() {
    verificarAcceso();

    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  mounted() {
    this.key = sessionStorage.getItem("key");
    this.modelsNotice();
    this.getGPSModels();
    this.getEndUsers();

    this.getAreas();
    this.obtenerAreasPorUserAdministrativo()

    this.getConfiguraciones()
  },
  computed: {
    translateLabel() {
      if (this.txtImei === null) return this.$t("vDispositivos.msgDato");
      else return this.txtImei;
    },
    translateFormat() {
      if (this.txtFormato === "IMEI") return this.$t("vDispositivos.msgImei");
      if (this.txtFormato === "ID") return this.$t("vDispositivos.msgId");
    },

    translateRadio() {
      return this.options.map((el) => {
        return {
          ...el,
          text: this.$t(`tableHeaders.${el.text}`),
        };
      });
    },

    imeiState() {
      return this.dispositivo.imei.match(this.pattern) ? true : false;
    },

    // passwordState mantiene tu lógica de 6 dígitos
    passwordState() {
      return this.dispositivo.contrasena.match("^\\d{6}$") ? true : false;
    },

    imeiInstState() {
      return this.dispositivoInstitucional.imei.length === 15 &&
        this.dispositivoInstitucional.imei.trim() !== ""
        ? true
        : false;
    },

    serialInstState() {
      return this.dispositivoInstitucional.serial.length === 9 &&
        this.dispositivoInstitucional.serial.trim() !== ""
        ? true
        : false;
    },

    countryOptions() {
       return countries.map(c => ({
        iso: c.iso,
        label: `${c.bandera} ${c.paisNombre} (${c.dialCode})`,
        dialCode: c.dialCode
      }))
    },

    // dial code que se muestra en el input prepend
    selectedDialCode() {
      const c = countries.find(
        (country) => country.iso === this.selectedPaisId.iso
      );
      return c ? c.dialCode : "";
    },

    
    phoneComputed() {
      const raw = (this.dispositivo.telefono || "").trim();
      
      // ✅ Si está vacío → marcar como inválido
      if (!raw) {
        this.phoneValidationMessage = 'El campo teléfono es obligatorio';
        return false;
      }

      if (!raw) {
        return { state: null, message: '' };
      }

      const norm = this._normalizeInput(raw);
      const iso = this.selectedPaisId.iso || 'MX';
      const regex = this.regexMap[iso];

      if (!regex) {
        const onlyDigits = norm.replace(/^\+/, '').replace(/\D/g, '');
        if (onlyDigits.length < 6 || onlyDigits.length > 15) {
          return { state: false, message: 'Longitud inválida' };
        }
        return { state: true, message: '' };
      }

      const ok = regex.test(norm);
      return { state: ok, message: ok ? '' : `Número inválido para ${iso}` };
    },

    // Accesos directos para usar en el template
    phoneState() {
      return this.phoneComputed.state;
    },
    /*phoneValidationMessage() {
      return this.phoneComputed.message;
    },*/

    selectedCountry() {
      return countries.find((c) => c.iso === this.selectedPaisId.iso) || null;
    },

  },
  methods: {
    async getConfiguraciones(){
      try {
        const response = await ConfiguracionesDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        const config = decoded[0];

        // Buscamos en nuestra lista de opciones el objeto real 
        // para que tenga la bandera y el formato correcto
        const paisCompleto = this.countryOptions.find(opt => opt.iso === config.iso);

        if (paisCompleto) {
          this.selectedPaisId = paisCompleto;
        } else {
          // Si no existe en la lista, creamos un objeto compatible al vuelo
          this.selectedPaisId = {
            iso: config.iso,
            dialCode: config.dialCode,
            label: `${config.paisNombre} (${config.dialCode})`
          };
        }

      } catch (error) {
        console.error("Error:", error);
      }
    },

    limpiarTexto(texto) {
      return texto.split("*")[0].trim();
    },

    mostrarCard(selectedGps) {
      this.mostrar = selectedGps === "1";
    },

    contarDigitos() {
      if (this.isGenericGPS) {
        if (this.dispositivo.imei.length < 10) this.txtFormato = "ID";
        if (
          this.dispositivo.imei.length > 10 &&
          this.dispositivo.imei.length < 15
        )
          this.txtFormato = "IMEI";
      }
    },
    /**
     * Método encargado de invocar una alerta con la información
     * de los modelos de GPS compatibles con el sistema.
     */
    modelsNotice() {
      this.$swal({
        title: this.$t("vDispositivos.modelCompat"),
        text:
          "COBAN TK108, TKSTAR 905, TKSTAR 909 " +
          this.$t("vDispositivos.y") +
          " TKSTAR 913.",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Gral.aceptar"),
        iconColor: "gray",
        reverseButtons: true,
      });
    },

    /**
     * Método encargado de obtener los modelos de gps registrados en bd
     */
    async getGPSModels() {
      try {
        const response = await ModelosDataService.getAllHabilitados();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.gpsModelList = decoded;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Método encargado de obtener los usuarios finales registrados en bd
     */
    async getEndUsers() {
      try {
        const response = await UsersDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.endUsersList = decoded.filter(
          (value) => value.rol.id === process.env.VUE_APP_ID_USUARIO_FINAL
        );
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Método encargado de obtener los grupos registrados en la bd
     */
    async getAreas() {
      
      try {
        const response = await AreaDataService.getHabilitados();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.areasList = decoded;
        //this.isMaster =sessionStorage.idRol == process.env.VUE_APP_ID_MASTER ? true : false;
        this.isMaster = this.esUsuarioMaster();
      } catch (error) {
        console.log(error);
      }
    },

    /** Método encargado de setear la información del dispositivo GPS a registrar. */
    prepareDataForGPSRegistration() {
      // Esta validación se hace solo para usuarios Administradores
      if (sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR) {
        this.selectedAreaId = sessionStorage.areaUser;
      }      

      return {
        nombre: this.dispositivo.nombre,
        contrasena: this.dispositivo.contrasena,
        imei: this.dispositivo.imei,
        telefono: this.dispositivo.telefono,
        usuarios: this.dispositivo.usuarios,
        modelo: this.dispositivo.modelo, //Aqui se guarda la marca del gps
        model: this.gpsModelList.find(
          (item) => item.id == this.selectedGPSModel.id
        ),
        area: this.areasList.find((item) => item.id == this.selectedAreaId.id),
        compartirLink: this.dispositivo.compartirLink,
        compartirHasta: this.dispositivo.compartirHasta,
        tipo: "Comercial",
        serial: "",
        iso: this.selectedCountry.iso,
        paisNombre: this.selectedCountry.paisNombre,
        dialCode: this.selectedCountry.dialCode
      };
    },

    //Data para registrar dispositivo institucional
    prepareDataDipoInst() {
      // Esta validación se hace solo para usuarios Administradores
      if (sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR) {
        this.selectedAreaId = sessionStorage.areaUser;
      }

      return {
        nombre: this.dispositivoInstitucional.nombre,
        contrasena: "",
        imei: this.dispositivoInstitucional.imei,
        telefono: "",
        usuarios: this.dispositivoInstitucional.usuarios,
        modelo: "GPSAU",
        model: null,
        area: this.areasList.find((item) => item.id == this.selectedAreaId.id),
        compartirLink: this.dispositivoInstitucional.compartirLink,
        compartirHasta: this.dispositivoInstitucional.compartirHasta,
        tipo: "Institucional",
        serial: this.dispositivoInstitucional.serial,
      };
    },

    /** Método encargado de obtener la propiedad representante del GPS (ID o IMEI).
     * @param marca Marca del GPS.
     * @returns identidad unica del GPS.
     */
    getTxtProperty(marca) {
      let property = ""; //Texto para concatenar con el dato IMEI/Id
      switch (marca) {
        case "TKSTAR": // Marca: TKSTAR
          property = "Id";
          break;
        case "TK108": //Marca: COBAN
          property = "IMEI";
          break;
        default: // Marca: Registrada por el usuario (genérica)
          property = this.txtFormato == "ID" ? "Id" : "IMEI";
      }
      return property;
    },

    async registrarDispositivoInst() {
      try {
        const data = this.prepareDataDipoInst();

        const response = await DevicesDataService.create(data, this.key);
        if (response.status === 200) {
          Utils.generalSweetAlert(
            this.$t("vDispositivos.msgDispoReg"),
            "success"
          );
          this.$router.push("/dispositivos");

          this.accion =
            "Agregó el dispositivo " + data.nombre + " con IMEI " + data.imei;
          this.registrarAccion();
        }
      } catch (e) {
        if (e.response.status === 400) {
          const error = await Crypto.desencriptar(e.response.data, this.key);
          let titulo;

          switch (error) {
            case 1:
            case 2:
              this.estatusImei = true;
              break;
            case -1:
            case -2:
              this.estatusSerial = true;
              break;
            default:
              titulo = this.$t("Gral.msgErrorDesconocido");
              Utils.generalSweetAlert(titulo, "error");
          }
        }
      }
    },

    /** Método encargado de hacer el registro del GPS en el sistema. */
    registrarDispositivo() {
      const data = this.prepareDataForGPSRegistration();
      const property = this.getTxtProperty(data.modelo);

      DevicesDataService.create(data, this.key)
        .then(() => {
          this.accion =
            "Agregó el dispositivo " +
            data.nombre +
            " con " +
            property +
            " " +
            data.imei;
          this.registrarAccion();
          this.submitted = true;
          Utils.generalSweetAlert(
            this.$t("vDispositivos.msgDispoReg"),
            "success"
          );

          this.busy = false;

          if (this.btn) {
            document.getElementById("nombre").value = "";
            document.getElementById("password").value = "";
            document.getElementById("imei").value = "";
            document.getElementById("telefono").value = "";
            this.selectedAreaId = null;
            this.filtro = null;
            this.pattern = "^\\d{-1}$";
            this.dispositivo = {
              id: 0,
              nombre: "",
              contrasena: "",
              imei: "",
              telefono: "",
              usuarios: [],
            };
          } else {
            this.$router.push("/dispositivos");
          }
          this.btn = false;
        })
        .catch(async(e) => {
          //this.busy = false;
          var titulo;

          if (e.response.status === 400) {
            let error = await Crypto.desencriptar(e.response.data, this.key);
            switch (error) {
              case 1:
                this.estatusImei = true;
                break;
              case 2:
                titulo = this.$t("vDispositivos.msgImeiDel");
                Utils.generalSweetAlert(titulo, "error");
                break;
              case -1:
                this.estatusTelefono = true;
                break;
              case -2:
                titulo = this.$t("vDispositivos.msgTelExiste");
                Utils.generalSweetAlert(titulo, "error");
                break;
            }
          } else if (e.response.status === 403) {
            titulo = this.$t("vDispositivos.msgErrorDispo");
            Utils.generalSweetAlert(titulo, "error");
          }

          if (e.response.status === 200) {
            Utils.generalSweetAlert(titulo, "error");
          }
        });
    },

    newDispositivo() {
      this.submitted = false;
      this.dispositivo = {};
    },

    /**
     * Método encargado de enlistar los usuarios que pertenecen
     * a un área especifica.
     */
    inputSelect() {
      this.$emit(
        "input",
        this.selected.forEach((i) =>
          this.endUsersList.find((item) => item.id === i)
        )
      );

      this.usersByGroupList = [];
      this.dispositivo.usuarios = null;
      this.dispositivoInstitucional.usuarios = null;
      this.endUsersList.forEach((value, index) => {
        if (value.area != null) {
          if (value.area.id == this.selectedAreaId.id) {
            this.usersByGroupList.push(value);
          }
        }
      });
    },

    inputSelectPais(val) {
      this.selectedPaisId = val;
      // revalidar número actual para dar feedback inmediato
      const v = this.dispositivo.telefono || "";
      const res = this.isPhoneValidByRegex(v, val);
      this.phoneValidationMessage = res.message;
    },

    // normaliza entrada: elimina espacios, guiones, paréntesis; mantiene + si está al inicio
    _normalizeInput(raw) {
      if (!raw && raw !== "") return "";
      let v = String(raw);
      // quitar separadores comunes (espacios, -, ., paréntesis)
      v = v.replace(/[\s\-\.\(\)]/g, "");
      // si hay más de un +, dejar solo el primero
      const pluses = (v.match(/\+/g) || []).length;
      if (pluses > 1) {
        // mantener solo el primer +
        v = v.replace(/\+/g, (m, offset) => (offset === v.indexOf("+") ? "+" : ""));
      }
      return v;
    },

    // validación por regex pura (útil si quieres validarla manualmente desde métodos)
    isPhoneValidByRegex(raw, iso = null) {
      const norm = this._normalizeInput(raw);
      if (!norm) return { valid: null, message: "" };

      const countryIso = iso || this.selectedPaisId.iso || "MX";
      const regex = this.regexMap[countryIso];

      if (!regex) {
        const onlyDigits = norm.replace(/\D/g, "");
        if (onlyDigits.length < 6 || onlyDigits.length > 15) {
          return { valid: false, message: "Longitud inválida" };
        }
        return { valid: true, message: "" };
      }

      const ok = regex.test(norm);
      return {
        valid: ok,
        message: ok ? "" : `Número inválido para ${countryIso}`,
      };
    },

    // onPhoneInput: limpia y deja solo caracteres permitidos (digitos y + al inicio)
    onPhoneInput() {
      let v = this.dispositivo.telefono || "";
      // permitimos + sólo al inicio y dígitos; eliminamos resto (mantener espacios si quieres, aquí los quitamos)
      v = v.replace(/[^\d+]/g, "");
      // si hay + en otra posición, mover al inicio o eliminar duplicados
      const firstPlus = v.indexOf("+");
      if (firstPlus > 0) {
        // mover + al inicio
        v = "+" + v.replace(/\+/g, "");
      } else if (firstPlus === -1) {
        // no hay +
        v = v.replace(/\+/g, "");
      } else {
        // firstPlus === 0 : hay un + al inicio, quitar otros
        v = "+" + v.slice(1).replace(/\+/g, "");
      }
      this.dispositivo.telefono = v;

      // validar rápido y actualizar mensaje
      const res = this.isPhoneValidByRegex(v, this.selectedPaisId);
      this.phoneValidationMessage = res.message;
      // phoneState computed se re-evaluará automáticamente
    },

    validaciones() {
      
      return !(this.imeiState && this.phoneState && this.passwordState && this.selectedAreaId && this.dispositivo.usuarios);
    },

    validacionesDispoInst() {
      return !(this.imeiInstState && this.serialInstState && this.selectedAreaId && this.dispositivoInstitucional.usuarios);
    },

    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    modeloSelected() {
      //dependiendo del modelo seleccionado, se cambiara el campo imei/id de forma dinamica
      let gpsModelObject = "";
      gpsModelObject = this.gpsModelList.find(
        (item) => item.id === this.selectedGPSModel.id
      );

      if (gpsModelObject.marca.marca == "COBAN")
        this.dispositivo.modelo = "TK108";
      else this.dispositivo.modelo = gpsModelObject.marca.marca;

      this.$emit("input", (this.filtro = this.dispositivo.modelo));

      //dependiendo del modelo seleccionado, se cambiará la cabecera del campo a ID o IMEI, asi como la expresion regular que valida el largo del campo
      switch (this.filtro) {
        case "TKSTAR": //Si la marca es TKSTAR
          this.txtImei = "ID* :";
          this.txtFormato = "ID";
          this.pattern = "^\\d{10}$";
          this.isGenericGPS = false;
          break;

        //Si la marca es COBAN (modelo TK108) o Concox (modelo VL-103)
        case "TK108":
        case "Concox":
          this.txtImei = "IMEI* :";
          this.txtFormato = "IMEI";
          this.pattern = "^\\d{15}$";
          this.isGenericGPS = false;
          break;

        default: //Si la marca es "Generica"
          this.isGenericGPS = true;
      }
    },

    /**
     * obtenerAreas
     * Metodo que obtiene las areas asignadas a un usario administrativo
     * @autor DPA
     */
    async obtenerAreasPorUserAdministrativo() {
      
      const usuarioFiltroString = sessionStorage.getItem('usuarioFiltro');

      const estado =(usuarioFiltroString === null || usuarioFiltroString === '' || usuarioFiltroString === 'null') ? 'VACIO' : 'CON VALOR';

      let id_user;

      if (estado === 'CON VALOR') {
        const isUserFiltrado = JSON.parse(usuarioFiltroString);
        id_user = isUserFiltrado.id;
      } else {
        id_user = sessionStorage.getItem('id_user');
      }

      try {
        const response = await AreaDataService.getAreasPorAdministrador(id_user,this.key);

        this.areasListForUserAdministrador = await Crypto.desencriptar(response.data, this.key);
        this.isMaster = this.esUsuarioMaster();

      } catch (error) {
        console.error('Error al obtener áreas por administrador:', error);
      }
    },


    esUsuarioMaster() {
      
        const isUserFiltradoString = sessionStorage.getItem("usuarioFiltro");
      
        if (isUserFiltradoString != 'null' && isUserFiltradoString != '' && isUserFiltradoString != null) {
            //Es un usuario master que accedio a vista de Administrador
            try {
                const isUserFiltrado = JSON.parse(isUserFiltradoString);

                if (isUserFiltrado.rol.id === "6081c4becaae9b0d5e87e61b") {
                    return false;
                }
            } catch (e) {
                console.error("Error al parsear usuarioFiltro:", e);
                return true;
            }
        } else {
          if (sessionStorage.idRol === "6081c4becaae9b0d5e87e61b") {
            // Es usuario administrador
            return false;
          }else if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
            // 4. Comprobación final del rol Master (basado en el usuario logueado)
            return true;
          }
        }

        // Si ninguna condición se cumple, por defecto devolvemos false (si no es Master y si el filtro no era el especificado)
        return true;
    },



  },//END METHODS

  watch: {
    isGenericGPS(value) {
      if (value) {
        // this.txtImei = this.$t('vDispositivos.msgDato');
        this.txtImei = "Ingresa ID o IMEI* :";
        this.pattern = "^\\d{10}(?:\\d{5})?$";
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.tipo-dispositivo {
  font-size: 20px;
  font-weight: 500;
}

.submit-form {
  max-width: 400px;
}

.multiselect__tag {
  background: #0e7db9;
}

.country-badge {
  font-size: 1.2rem;
  line-height: 1;
}

@media (max-width: 600px) {
  .card {
    margin-top: 10px !important;
  }
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 200px;
  }
}

@media (max-width: 959px) {
  .margin-top-div {
    margin-top: -22px;
  }
}

@media (min-width: 960px) {
  .margin-top-div {
    margin-top: 0px;
  }
}

@media (min-width: 1200px) {
  .ancho-boton {
    width: 300px;
  }
}

@media (min-width: 2560px) {

  /* 1. Contenedor y Título */
  .d-flex.mt-4 {
    align-items: center !important;
    gap: 2rem !important;
  }

  .d-flex.mt-4 p {
    font-size: 2.2rem !important;
    /* Un poco más grande para legibilidad */
    margin-right: 2rem !important;
    margin-bottom: 0 !important;
  }

  /* 2. Opciones de Radio */
  .custom-control.custom-radio {
    display: inline-flex !important;
    align-items: center !important;
    margin-right: 6rem !important;
    padding-left: 0 !important;
    /* Limpieza total */
    position: relative !important;
    min-width: 200px !important;
  }

  /* 3. El Círculo Base (Fondo Azul/Gris) */
  .custom-control-input~.custom-control-label::before {
    content: "" !important;
    display: block !important;
    position: absolute !important;
    left: 0 !important;
    /* Forzamos posición 0 */
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 3.5rem !important;
    height: 3.5rem !important;
    margin: 0 !important;
    /* Eliminamos cualquier margen que lo empuje */
    background-color: #f8f9fa !important;
    border: 2px solid #adb5bd !important;
    border-radius: 50% !important;
    box-shadow: none !important;
  }



  /* 4. El Punto Blanco (Capa Superior) */
  .custom-control-input~.custom-control-label::after {
    content: "" !important;
    display: block !important;
    position: absolute !important;
    /* Centrado manual: (3.5 / 2) - (1.2 / 2) = 1.15rem */
    left: 1.15rem !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 1.2rem !important;
    height: 1.2rem !important;
    margin: 0 !important;
    background-image: none !important;
    border-radius: 50% !important;
  }

  /* Color cuando está seleccionado */
  .custom-control-input:checked~.custom-control-label::before {
    background-color: #4466f2 !important;
    border-color: #4466f2 !important;
  }

  /* Mostrar punto blanco solo al marcar */
  .custom-control-input:checked~.custom-control-label::after {
    background-color: white !important;
  }

  /* 5. Texto de la etiqueta (Separación total) */
  .inputRadioGroup {
    margin-right: 4rem !important;
  }

}
</style>
